// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowThinRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="9" viewBox="0 0 4 9" fill="currentColor">
            <path
                fill="#666"
                d="M706.030748,1042.00289 C705.883771,1042.16012 705.646607,1042.15705 705.500591,1042.02989 L702.001841,1038.97555 L698.502623,1042.03016 C698.348076,1042.16373 698.111451,1042.152 697.972466,1042.00316 C697.834654,1041.85288 697.847076,1041.62333 698.000826,1041.48924 L701.729732,1038.21645 C701.873287,1038.09215 702.08856,1038.09215 702.232232,1038.21645 L705.961139,1041.48924 C706.15731,1041.62333 706.169028,1041.85288 706.030747,1042.00289 L706.030748,1042.00289 Z"
                transform="rotate(90 870 172.123)"
            />
        </svg>
    );
};

export default React.memo(IconArrowThinRight);
